exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".IndexBox {\n  padding-top: 100px;\n}\n.IndexBox h1 {\n  color: #333;\n  font-size: 22px;\n  margin: 0;\n  padding: 0;\n}\n.IndexBox p {\n  color: #666;\n  font-size: 16px;\n  margin: 0;\n  padding: 0;\n}\n.IndexBox .IndexBG {\n  text-align: center;\n}\n.IndexBox .IndexBG img {\n  width: 200px;\n  margin: 20px;\n  margin: 32px 0 20px 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@brand-primary":"#1DA57A","@primary-button-fill":"#1DA295"}}!./src/pages/index/index.less
// module id = 521
// module chunks = 0